// extracted by mini-css-extract-plugin
export default {"AllCities":"AllCities_AllCities__U1-om"};